import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import { Modal } from "components/modal/Modal";
import { AssinaturaRenovar } from "./AssinaturaRenovar";
//import { Renovacao } from "./Renovacao";

export class AssinaturaDetalhes extends Component {
  constructor (props) {
    super(props);

    this.state = {
      renewModal: false
    };
    
    this.closeRenewModal = this.closeRenewModal.bind(this);
    this.toggleRenewModal = this.toggleRenewModal.bind(this);
  }

  closeRenewModal () {
    this.toggleRenewModal();
  }

  toggleRenewModal () {
    this.setState({
      renewModal: !this.state.renewModal
    });
  }

  render () {
    const { props, state } = this;

    return (
      <div>
        <h4>Details Details</h4>

        <Modal visible={this.state.renewModal} 
               onCloseModal={this.closeRenewModal}
               useDefaultDialog={false}>
          <AssinaturaRenovar 
            subscriberId={props.subscriberId}
            onCancel={this.closeRenewModal}/>
        </Modal>

        <button className={"btn btn-light-lime"}
                onClick={this.toggleRenewModal}>
          Renovar Assinatura
        </button>

        <NavLink to={"/assinaturas"}>
          &lsaquo; Voltar
        </NavLink>
      </div>
    );
  }
}

AssinaturaDetalhes.propTypes = {
  subscriberId: PropTypes.number.isRequired
};
